import React from "react";

export const commonMergeWarning = <div>Each project being merged will be saved as a PDF report in a Job Journal entry on the new merged project. This
    Job Journal entry can be used to reference previously completed tasks prior to the merge.</div>;

export const mergePreTaskWarningMsg = <div style={{color:'red'}}>Warning: Pre-E Forms that are ‘Ready for Energization’ may be reverted to ‘In Progress’.</div>;

export const mergeTaskWarningMsg = (<div>For each Project Task Section, the Task Version being kept in the final merged project will be highlighted in yellow.
    If the same Task Version is coming from multiple projects, each task status will be compared between those projects
    and the earliest Task Status, Name, and Date will be kept per task. Task Versions which are not highlighted will be
    overwritten after being saved in the PDF Report.</div>);

export const mergeInvalidProjectMsg = <div style={{color:'red'}}>Projects with CIP Security cannot be merged with projects that have an already Energized Pre-E Form,
    unless all CIP Security Tasks are 100% complete for all projects with CIP Security.</div>;